import React from 'react';
//import React, { Component } from 'react';
import './App.css';


import {render} from 'react-dom';
import './index.css';
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";





import {Header} from './components/Header';

import {Footer} from './components/Footer';
import {NavProductos} from './components/NavProductos';
import {arandelas} from './components/arandelas';
import {hidraulica_neumatica} from './components/hidraulica_neumatica';
import {bulones} from './components/bulones';
import {tornillos} from './components/tornillos';
import {tuercas} from './components/tuercas';
import {elem_roscados} from './components/elem_roscados';
import {elem_fijacion} from './components/elem_fijacion';
import {grampas_ganchos} from './components/grampas_ganchos';
import {elementos_d_corte} from './components/elementos_d_corte';
import {herramienta_accesorio} from './components/herramienta_accesorio';
import {productos_quimicos} from './components/productos_quimicos';
import {bulones_automotor} from './components/bulones_automotor';
import {elem_seguridad} from './components/elem_seguridad';
import {herram_automotor} from './components/herram_automotor';
import {soldadura} from './components/soldadura';
import {clavos_alambres} from './components/clavos_alambres';
import {pegamentos} from './components/pegamentos';
import {quienes_somos} from './components/quienes_somos';
import {ubicacion} from './components/ubicacion';
import {Contactos} from './components/Contactos';
import {error} from './components/error';
import registerServiceWorker from './registerServiceWorker';







class App extends React.Component {



  render() {
    return (
    	<Router>
		    <div class="dashboard row">
		    	<div class="info-dashboard-address col-md-12">
		    		<span><img src="/imga/tel.png"/>Telefonos: (011) 4207-2880/7719/6914  <img src="/imga/wa.png"/>Whatsapp: (011) 2526-7412 </span>
		    		<span><img src="/imga/location.png"/>Av. Bartolomé Mitre 6163, Wilde, Buenos Aires</span>
		    		<span><img src="/imga/mail.png"/>elemporiodelbulon@gmail.com</span>
		    	</div>
				<div class="nuevo-header col-md-12">
				<nav class="navbar navbar-expand-lg navbar-light">
						<a class="navbar-brand displaynone-mobile" href="#"><img src="/imga/logo-emporio.png"/></a>	
						<a class="navbar-brand displaynone-desktop" href="#"><img src="/imga/logo-emporio.png"/></a>
						<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
							<span class="navbar-toggler-icon"></span>
						</button>
						<div class="collapse navbar-collapse justify-content-end mobileNavScroll" id="navbarNav">
							
							<ul class="nav-productos-lb displaynone-desktop">
								<li class="nav-item">
									<NavLink className="topScroll"  to="/Arandelas">Arandelas</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/bulones">Bulones</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" exact={true} to="/">Tornillos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/tuercas">Tuercas</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-roscados-varios">Elementos roscados varios</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/accesorios-hidraulica-neumatica">Accesorios hidraulica/neumatica</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-sujecion-fijacion">Elementos de sujecion/fijacion</NavLink>
								</li>


								<li class="nav-item">
									<NavLink className="topScroll" to="/grampas-ganchos">Grampas/Ganchos</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-de-corte">Elementos de corte</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/herramientas-accesorios">Herramientas/accesorios</NavLink>
								</li>

								<li class="nav-item">
									<NavLink className="topScroll" to="/productos-quimicos">Productos quimicos</NavLink>
								</li>
								
								<li class="nav-item">
									<NavLink className="topScroll" to="/bulones-automotor">Bulonería automotor</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/elementos-de-seguridad">Elementos de seguridad</NavLink>
								</li>

								<li class="nav-item">
									<NavLink className="topScroll" to="/herramientas-automotor">Herramientas de automotor</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/soldadura">Soldadura</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/clavos-alambres">Clavos y alambres</NavLink>
								</li>
								<li class="nav-item">
									<NavLink className="topScroll" to="/pegamentos">Pegamentos</NavLink>
								</li>
							</ul>



							<ul class="navbar-nav ap-nav">
								<li class="nav-item li-item li-section-header-link">
									<NavLink activeClassName={"active"} exact={true} to="/quienes-somos">Quienes somos</NavLink>
								</li>
								<li class="nav-item li-item li-section-header-link">
									<NavLink activeClassName={"active"} to="/ubicacion">Ubicación</NavLink>
								</li>
								<li class="nav-item li-item li-section-header-link">
									<NavLink activeClassName={"active"} to="/contactos">Contacto</NavLink>
								</li>
							</ul>
				    		
						</div>
					</nav>
				</div>
		    	<div class="columna-uno displaynone-mobile col-md-2">
		    		
		    		<NavProductos />

		    		
		    	</div>
		    	<div class="columna-dos col-md-10">
		    		
					<Route  path="/arandelas" component={arandelas} />
					<Route  path="/bulones" component={bulones} />
					<Route  exact={true} path="/" component={tornillos} />
					<Route  path="/tuercas" component={tuercas} />
					<Route  path="/elementos-roscados-varios" component={elem_roscados}/>
					<Route  path="/accesorios-hidraulica-neumatica" component={hidraulica_neumatica}/>
					<Route  path="/elementos-sujecion-fijacion" component={elem_fijacion} />
					<Route  path="/grampas-ganchos" component={grampas_ganchos} />
					<Route  path="/elementos-de-corte" component={elementos_d_corte} />
					<Route  path="/herramientas-accesorios" component={herramienta_accesorio} />
					<Route  path="/productos-quimicos" component={productos_quimicos} />
					<Route  path="/bulones-automotor" component={bulones_automotor} />
					<Route  path="/elementos-de-seguridad" component={elem_seguridad} />	
					<Route  path="/herramientas-automotor" component={herram_automotor} />
					<Route  path="/soldadura" component={soldadura} />
					<Route  path="/clavos-alambres" component={clavos_alambres} />
					<Route  path="/pegamentos" component={pegamentos} />			
					<Route  path="/contactos" component={Contactos} />
					<Route  path="/ubicacion" component={ubicacion} />
					<Route  path="/quienes-somos" component={quienes_somos} />
					
		    	</div>
		    	
		      
				
		    </div>
  		</Router>
      
    );
  }
};



render(<App />, document.getElementById('root'));
registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js